import { useRouterTracking } from '@/hooks/use-router-tracking';

export function RouterTrackingWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  // Track route changes
  useRouterTracking();

  return <>{children}</>;
}
